import React from "react";
import Skeleton from "@mui/material/Skeleton";
const AddressCard = (props) => {
  const card = (
    <div className="row ">
      <div className="col-12  m-0 p-0">
        <Skeleton
          sx={{ borderRadius: "10px", marginTop: "15px" }}
          animation="wave"
          variant="rounded"
          width={"100%"}
          height={155}
        />
      </div>
    </div>
  );
  const cards = [];
  for (let i = 0; i < 3; i++) {
    cards.push(card);
  }
  return cards.map((card, index) => <div key={index}>{card}</div>);
};
export default AddressCard;
